// extracted by mini-css-extract-plugin
export var container = "_5i-0";
export var infoButton = "_5i-1";
export var label = "_5i-3";
export var labelExpanded = "_5i-4";
export var price = "_5i-5";
export var priceExpanded = "_5i-6";
export var title = "_5i-2";